export default {
    path: "article",
    component: () => import("@/view/card/article/index"),
    redirect: "/card/article/page",
    name: "card-article",
    meta: {
        title: "文章"
    },
    children: [
        {
            path: "cate",
            name: "card-article-cate",
            component: () => import("@/view/card/article/cate"),
            meta: {
                title: "分类管理"
            }
        },
        {
            path: "page",
            name: "card-article-page",
            component: () => import("@/view/card/article/page"),
            meta: {
                title: "文章管理"
            }
        },
        {
            path: "edit",
            name: "card-article-edit",
            component: () => import("@/view/card/article/edit"),
            meta: {
                title: "文章编辑"
            }
        }
    ]
}